// auth.guard.ts (functional guard)
import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Router, UrlTree } from '@angular/router';
import { filter, from, map, of, switchMap, take } from 'rxjs';
import { environment } from '../../../environments/environment';
import { UtilityService } from '../../services/utility/utility.service';
import { AuthService } from '../services/auth/auth.service';

// If you MUST verify token server-side before allowing navigation, set this true.
const VERIFY_TOKEN_ON_EACH_ROUTE = true;

export const authGuard = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const util = inject(UtilityService);

  return toObservable(auth.authCheckedSig).pipe(
    filter(Boolean), // wait until initial auth check completes
    take(1),
    switchMap(() => {
      if (!auth.isAuthenticatedSig()) {
        return of(router.parseUrl('') as UrlTree);
      } else if (!auth.isAuthorizedSig()) {
        return of(router.parseUrl('/unauthorized') as UrlTree);
      }

      if (!VERIFY_TOKEN_ON_EACH_ROUTE) {
        return of(true);
      }

      const url = environment.loginApiUrl + '/Authorize';
      return from(auth.verifyTokenIfNeeded(() => util.getRequest(url))).pipe(
        map((ok) => (ok ? true : auth.login())),
      );
    }),
  );
};
